/**
 * A global namespace for the `selectend` event.
 */
const selectendEvent = "selectend";
export default selectendEvent;
